import t from "react";
import { t as r } from "./useKeyDown-88662051.mjs";
import { M as c } from "./useModal-5a548e10.mjs";
import { I as b, W as h } from "./Icon-e01b6482.mjs";
import { B as l } from "./Button-eec2778c.mjs";
const i = "bottom-sheet", S = "mobile", p = "desktop", d = "bottom-sheet__backdrop", _ = "bottom-sheet__header", f = "bottom-sheet__close-button", u = "bottom-sheet__main", B = "bottom-sheet__footer", e = {
  bottomSheet: i,
  mobile: S,
  desktop: p,
  bottomSheetBackdrop: d,
  bottomSheetHeader: _,
  bottomSheetCloseButton: f,
  bottomSheetMain: u,
  bottomSheetFooter: B
};
function x({
  isVisible: a,
  closeModal: o,
  heading: s,
  children: n,
  closeLabel: m = "Close"
}) {
  return a ? /* @__PURE__ */ t.createElement(
    c,
    {
      closeModal: o,
      className: e.bottomSheet,
      backdropClassName: e.bottomSheetBackdrop
    },
    /* @__PURE__ */ t.createElement("header", { className: e.bottomSheetHeader }, /* @__PURE__ */ t.createElement("h2", { className: r.textsComponentTitleBold }, s), /* @__PURE__ */ t.createElement(
      "button",
      {
        className: e.bottomSheetCloseButton,
        onClick: o,
        title: m
      },
      /* @__PURE__ */ t.createElement(b, { icon: h.CLOSE, size: 20 })
    )),
    /* @__PURE__ */ t.createElement("div", { className: e.bottomSheetMain }, n),
    /* @__PURE__ */ t.createElement("footer", { className: e.bottomSheetFooter }, /* @__PURE__ */ t.createElement(l.Secondary, { text: m, onClick: o }))
  ) : null;
}
export {
  x as B
};
//# sourceMappingURL=BottomSheet-e2c6dc93.mjs.map
